import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleBasedAdminService } from 'app/modules/role-based-admin/role-based-admin.service';
import { PageService } from 'app/services/page-service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-modern-sidebar',
  templateUrl: './modern-sidebar.component.html',
  styles: [
  ],
})
export class ModernSidebarComponent implements OnInit {
  
  isCollapsed = false;
  superAdminEnable = false;
  logoImage = environment.sidebarLogo
  logoIcon = environment.navLogo

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    const mainPanel =
      document.querySelector(".main-panel") as HTMLElement;
    const footer =
      document.querySelector(".footer") as HTMLElement;


    if (this.isCollapsed) {
      mainPanel.style.width =
        "calc(100% - 80px)";
      if (footer)
        footer.style.width =
          "calc(100% - 80px)";
    }

    else {
      mainPanel.style.width =
        "calc(100% - 260px)";
      if (footer)
        footer.style.width =
          "calc(100% - 260px)";
    }
  }

  public menuItems: any[];
  userDetails: any;
  roleName = "";
  showReferral = false;
  clientDetails =
    JSON.parse(localStorage.getItem("client"));
  projectName =
    this.clientDetails?.projectName
    || environment.projectName;
  defaultLogo =
    this.clientDetails?.logo
    || "/assets/images/marketplaceLogo.png";
  routeUrl = "";
  accountRoleId = "";
  adminEnable = false;
  roleUserEnable = false;
  permissions: any = {};
  menuVisibility: any = {};
  cityDashboardDisabled = false;
  couponFeature = false;
  platformConfig = false;
  notification = false;
  paymentSettings = false;
  faq = false;
  banners = false;
  platformConfigData = [];
   serviceMenu = false;
    platformType: any = [];




  constructor(
    public router: Router,
    public service: PageService,
    public roleService: RoleBasedAdminService,
  ) {}
 

  ngOnInit() {
    const appName =
      localStorage.getItem("clientName");

    if (
      environment.referralClients
      &&
      environment.referralClients
        .indexOf(appName) > -1
    ) {
      this.showReferral = true;
    }
   

    if (
      localStorage.getItem("permissionData")
    ) {
      this.permissions =
        JSON.parse(
          localStorage.getItem("permissionData")
        );
    }

    if (
      localStorage.getItem("accountRole")
    ) {
      this.accountRoleId =
        localStorage.getItem("accountRole");
      if (
        this.accountRoleId === "ADMIN"
        
      ) {
        this.adminEnable = true;
        this.superAdminEnable = false;
      } else if( this.accountRoleId === "SADMIN"){
        this.superAdminEnable = true;
        console.log(this.superAdminEnable)
      }
      else {
        this.roleUserEnable = true;
         this.superAdminEnable = false;
         console.log(this.superAdminEnable)
        this.getAccessRole();
        this.menuVisibility =
          this.generateMenuVisibility();
      }

       console.log(this.superAdminEnable)
   
    }

    this.routeUrl =
      this.router.url;

    if (
      environment.features
    ) {

      this.couponFeature =
        environment.features["couponNew"];

      this.platformConfig =
        environment.features["platformConfigNew"];

      this.notification =
        environment.features["notification"];

      this.paymentSettings =
        environment.paymentSettings;

      this.faq =
        environment.features["faq"];

      this.banners =
        environment.features["banners"];

    }
    try {
      this.userDetails =
        JSON.parse(
          localStorage.getItem("userDetails")
        );
    }
    catch {}
this.getPlatformConfig();
  }


  generateMenuVisibility() {
    const visibility = {};
    for (
      const key in this.permissions
    ) {
      visibility[key] =
        this.permissions[key]?.view || false;
    }
    return visibility;

  }

  getAccessRole() {
    const data = {
      roleID: this.accountRoleId,
    };
    this.roleService
      .getAccessRole(data)
      .then((response) => {
        this.roleName =
          response["data"]["role"]["name"];
      })
      .catch((err) => {
        console.log(err);
       
      });

  }

   getPlatformConfig() {
    this.service.getplatformConfig().then((data) => {
      this.platformConfigData = data["Data"];
      // console.log(this.platformConfigData);
      if (data["Data"] && data["Data"]["platformType"]) {
        this.platformType = data["Data"]["platformType"];
      }
      if (!this.platformType.includes("service")) {
      } else {
        this.serviceMenu = true;
        // console.log(this.serviceMenu);
      }
    });
  }
}